// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  viewer: __t.identity(),
  buildingId: __t.u64().name("building_id"),
  restaurantId: __t.u64().name("restaurant_id"),
  owner: __t.identity(),
  lifecycle: __t.string(),
  isYou: __t.bool().name("is_you"),
  refreshedAt: __t.timestamp().name("refreshed_at"),
});
